import { InternalAxiosRequestConfig } from "axios";
import toast from "react-hot-toast";
import { Config } from "../../config/config";

const url = Config.API;

export const RequestInterceptor = (config: InternalAxiosRequestConfig) => {
  if (!window.navigator.onLine) {
    toast.error("Please check your internet connection, you might be offline.");
    clearSession()
    throw new Error("No Internet connection.");
  }

  const accessToken = localStorage.getItem("R_M_t");

  if (accessToken) {
    (config as any).headers.authorization = `Bearer ${accessToken as any}`;
  }

  config.url = url + config.url;

  return config;
};

// export const onErrorResponseInterceptor = (error: any) => {

// 	if (error.response.data.message === 'Unauthorized') {
// 		window.location.replace('/logout');
// 	} else {
// 		return Promise.reject(error);
// 	}
// };
export const onErrorResponseInterceptor = (error: any) => {
  if (error.response && error.response.status === 403) {
    clearSession();
    // window.location.replace('/logout');
  } else {
    return Promise.reject(error);
  }
};
const clearSession = () => {
  localStorage.removeItem("R_M_t");
  localStorage.removeItem("R_M_uid");
  localStorage.removeItem("R_M_exp");
  window.location.replace(`${Config.feUrl}logout`);
  return
};

export const runlogoutTimer = () => {
  const expiresIn = localStorage.getItem("R_M_exp");

  console.log(expiresIn, "p");

  if (expiresIn && parseInt(expiresIn) !== 0) {
    const valid = new Date() < new Date(parseInt(expiresIn));
    const timeLeft =
      new Date(parseInt(expiresIn)).valueOf() - new Date().valueOf();

    if (!valid) {
      clearSession();
      return;
    }

    setTimeout(() => clearSession(), timeLeft);
  }
};
